import { Village } from '@/constants';
import { useReadyInfo } from '@/providers/ReadyProvider';
import { fetchLogout } from '@/services/login';
import { useRequest } from 'ahooks';
import React, { useState } from 'react';
import { Header } from 'rsuite5';
import { Modal } from '../Bicester';
import Image from '../Bicester/Image';
import Profile from './Profile';

const BicesterHeader = () => {
  const { profile, setProfile } = useReadyInfo();

  const [logoutModal, setLogoutModal] = useState({
    show: false,
    content: '确认登出吗？',
    confirm: '是',
    cancel: '否',
    onConfirm: null,
  });

  // 登出
  const { run: logout, loading: logoutLoading } = useRequest(fetchLogout, {
    manual: true,
  });

  const handleHideModal = () => {
    setLogoutModal({
      ...logoutModal,
      show: false,
    });
  };

  const handleLogout = () => {
    logout().then((res) => {
      window.location.reload();
      setProfile({});
    });
    handleHideModal();
  };

  return (
    <>
      <Header className="bicester-header">
        {profile && profile?.shopping_village ? (
          <a className="logo-wrapper" href={process.env.PUBLIC_PATH}>
            <Image
              src={`/resources/images/logo-bicester-${
                Village[profile?.shopping_village] || 'SH'
              }.png`}
              className="logo"
              alt="bicester"
            />
          </a>
        ) : (
          <a className="m-auto flex justify-between w-[500px]" href={process.env.PUBLIC_PATH}>
            <Image
              src="/resources/images/logo-bicester-SZ.png"
              className="w-[220px]"
              alt="bicester"
            />
            <Image
              src="/resources/images/logo-bicester-SH.png"
              className="w-[220px]"
              alt="bicester"
            />
          </a>
        )}
        {profile && (
          <Profile
            onLogout={() =>
              setLogoutModal({
                ...logoutModal,
                show: true,
                onConfirm: handleLogout,
              })
            }
          />
        )}
      </Header>
      <Modal
        loading={logoutLoading}
        show={logoutModal.show}
        content={logoutModal.content}
        confirm={logoutModal.confirm}
        cancel={logoutModal.cancel}
        onConfirm={logoutModal.onConfirm}
        onCancel={handleHideModal}
      />
    </>
  );
};

export default BicesterHeader;
